import React, {useCallback, useEffect, useState} from "react";
import useStyles from "isomorphic-style-loader/useStyles";
import classes from "./style.module.scss";
import {IMAGE_GEEKO_LTD} from "../../../../../../../constants";
import {useDispatch, useSelector} from "react-redux";
import {
    getDelPrice,
    getDelPriceWithVariant,
    getLowerPriceWithVariant,
    getPrices,
    unitPrice
} from "../../../../../../../utils/product";
import _ from "lodash";
import {SensorsTrack} from "../../../../../../utils/sensor";
import {Iconfont} from "../../../../../../components/icon/iconfont";
import ProductColor from "../../../../../details/components/product-main-container/product-color";
import ProductSize from "../../../../../details/components/product-main-container/product-size";
import {action_buy_now_checkout} from "../../../../../../../store/actions/pages/cart";
import {FormattedMessage} from "react-intl";

const Quantity = props => {
    useStyles(classes)
    const { quantity, itemChangeQtyHandle} = props
    const [qty, setQty] = useState(quantity)

    const debouncedHandle = useCallback(_.debounce(itemChangeQtyHandle, 400), [])

    const minusHandle = () => {
        SensorsTrack('QuickBuyAction', {action: 'ClickDecreaseQty'})
        if (qty > 1) {
            const q = qty - 1
            setQty(q)
            debouncedHandle(q)
        }
    }

    const addHandle =() => {

        SensorsTrack('QuickBuyAction', {action: 'ClickIncreaseQty'})

        const q = qty + 1
        setQty(q)
        debouncedHandle(q)
    }

    useEffect(() => {
        setQty(quantity)
    }, [quantity])

    const changeHandle = e => {
        const value = e.target.value
        if(value){
            setQty(value)
            debouncedHandle(value)
        }
    }


    return <span className={`${classes.Quantity}`}>
        <Iconfont onClick={minusHandle} className={classes.Icon}>&#xe731;</Iconfont>
        <input className={classes.Number} value={qty} type="number" onChange={changeHandle}/>
        <Iconfont className={classes.Icon} onClick={addHandle}>&#xe733;</Iconfont>
    </span>
}
export default props =>{
    useStyles(classes)
    const dispatch = useDispatch()
    const pageProduct = useSelector((state) => state.pageProduct)
    const [productVO, setProductVO] = useState(pageProduct.productVO)

    const {selectedProduct,selectedVariant,setHiddenComponent}=props
    const [selectedVariantFinal,setSelectedVariantFinal]=useState(selectedVariant?selectedVariant:null)
    const [selectedProductFinal,setSelectedProductFinal]=useState(selectedProduct)
    const [qty, setQty] = useState(1)
    const isBeautyMakeup = productVO?.style === 1;
    let prices = []
    if (selectedProductFinal?.variants) {
        prices = getPrices(selectedProductFinal?.variants)
    }
    const higher=getDelPriceWithVariant(selectedVariantFinal?selectedVariantFinal:selectedProduct?.variants?.[0])
    const lower= getLowerPriceWithVariant(selectedVariantFinal?selectedVariantFinal:selectedProduct?.variants?.[0])
    let off = 0
    if (higher) {
        off = Math.round((Number(higher.amount) - Number(lower.amount)) * 100 / Number(higher.amount))
    }
    const selectVariant =async (variantId, variant) => {
        variant ?
            setSelectedVariantFinal(variant) :
            setSelectedVariantFinal(selectedProductFinal?.variants?.find(v => v.id === variantId))
        // await actionBuyNow()
    }
    const selectProduct = async (productId, color, variant) => {
        const sp = productVO?.products?.find(p => p.id === productId && p?.variants[0]?.color === color) || productVO?.products?.find(p => p.id === productId)
        setSelectedProductFinal(sp)
        variant?setSelectedVariantFinal(variant):setSelectedVariantFinal(null)
        // await actionBuyNow()
    }
    const changeQtyHandle=async (qty)=>{
        setQty(qty)
        // await actionBuyNow()
    }
    useEffect(async ()=>{
        console.log("@ buy qty",qty)
        console.log("@ buy qty",selectedVariantFinal?selectedVariantFinal.id:null)
        if(selectedVariantFinal){
            setHiddenComponent(false)
        }
        await dispatch(action_buy_now_checkout({"variantId":selectedVariantFinal?selectedVariantFinal.id:null,qty:qty}))
    },[qty,selectedVariantFinal])
    // const actionBuyNow= useCallback(async(variantId,qty)=>{
    //     console.log("@ buy qty",qty)
    //     await dispatch(action_buy_now_checkout({"variantId":variantId.id,qty:qty}))
    // },[qty2,selectedVariantFinal])

    const productHooks={ isBeautyMakeup,
        productVO,
        selectedVariant:selectedVariantFinal,
        selectedProduct:selectedProductFinal,
        selectVariant,
        selectProduct,
        hiddenSizeCollectionSelector:true}
    return <React.Fragment>
        <div className={classes.ProductContainer}>
            <div className={classes.ProductInformation}>
                <div className={classes.Image}>
                    <img src={`${IMAGE_GEEKO_LTD}/large/${selectedProductFinal?.variants?.[0]?.image || selectedProductFinal.pcMainImage}`} />
                </div>
                <div className={classes.BasicInfomation}>
                    <div className={classes.mProductPrices}>
                        <div className={classes.PriceItem}>
                            <span className={classes.RealPrice} style={{ color: (higher ? "#e64545" : "#222") }}>
                                {unitPrice(lower)}
                            </span>
                            {
                                higher && <del className={classes.MrspPrice}>{unitPrice(higher)}</del>
                            }
                        </div>
                    </div>
                    {off>0&&<div className={classes.DiscountPercent}>
                            {`-${off}%`}
                        </div>
                    }
                    <Quantity itemChangeQtyHandle={qty => {changeQtyHandle(qty)}}  quantity={qty} />
                </div>

            </div>
            <div className={`${classes.SizeColorContainer}`}>
                <ProductColor productHooks={productHooks} />

                <ProductSize productHooks={productHooks} />
            </div>
            {!selectedVariantFinal&&<div className={classes.PleaseSelectSize}><span><FormattedMessage id="please_select_size" defaultMessage="Please Select a Size" /></span></div>}
        </div>
    </React.Fragment>
}